import "./CategoryDetailViewInfoComponent.scss";
import ViewSezioneComponent from "./components/ViewSezioneComponent/ViewSezioneComponent";
import ViewCategoryComponent from "./components/ViewCategoryComponent/ViewCategoryComponent";
import ViewSottoCategoryComponent from "./components/ViewSottoCategoryComponent/ViewSottoCategoryComponent";
import ViewErrorComponent from "./components/ViewErrorComponent/ViewErrorComponent";

/**
 * @function CategoryDetailViewInfoComponent renders the content of the categorie and sotto categorie
 * @returns {JSX.Element}
*/
const CategoryDetailViewInfoComponent = ( { info, isSection } ) => {

    const renderPage = () => {
        if ( isSection ) { return <ViewSezioneComponent info={info}></ViewSezioneComponent> }
        if ( info )
        {
            if ( info?.tipologia === "04" || info?.sottoVoci?.length ) return <ViewSottoCategoryComponent info={info} ></ViewSottoCategoryComponent>
            else return <ViewCategoryComponent info={info}></ViewCategoryComponent>;
        }
        return <ViewErrorComponent></ViewErrorComponent>;

    };

    return (
        <div className="CategoryDetailContainer">
            { renderPage() }
        </div>

    );
};

CategoryDetailViewInfoComponent.defaultProps = {
};

export default CategoryDetailViewInfoComponent;